import { useEffect } from 'react';
import { BaseCustomerChatbotConfigurationStyle } from '@endion/types';
import { MOUNT_ELEMENT_DATA_ATTR } from '../endion-chatbot';

export const TRIGGER_CLASSNAME = 'endion_trigger_position';
export const CHAT_VIEWPORT_CLASSNAME = 'endion_chat_viewport_position';
export function useSetStyle({ style }: { style: BaseCustomerChatbotConfigurationStyle | undefined }) {
  useEffect(() => {
    if (!style) return;
    // replace the primary color in the css variables
    const hexToRGB = (hex: string) => {
      const cleaned = hex.replace(/^#/, '');
      const num = parseInt(cleaned, 16);
      const r = (num >> 16) & 255;
      const g = (num >> 8) & 255;
      const b = num & 255;
      return `${r} ${g} ${b}`;
    };
    document.documentElement.style.setProperty('--color-primary', hexToRGB(style.primaryColor));

    const shadowRoot = document.querySelector(`[${MOUNT_ELEMENT_DATA_ATTR}]`)?.shadowRoot;
    if (!shadowRoot) return;
    const {
      position: { bottom, right },
      zIndex,
    } = style;
    const stylesheet = document.createElement('style');
    // adds chat viewport position class to the shadow root
    stylesheet.appendChild(
      document.createTextNode(
        `.${CHAT_VIEWPORT_CLASSNAME} {
         z-index: ${zIndex};
        }
        @media (min-width: 640px) {
              .${CHAT_VIEWPORT_CLASSNAME} {
                bottom: ${bottom}px;
                right: ${right}px;
              }
            }`,
      ),
    );
    // adds trigger position class to the shadow root
    stylesheet.appendChild(
      document.createTextNode(`.${TRIGGER_CLASSNAME} { bottom: ${bottom}px; right: ${right}px; z-index: ${zIndex}; }`),
    );

    shadowRoot.appendChild(stylesheet);
    return () => {
      shadowRoot.removeChild(stylesheet);
    };
  }, [style]);
}
